import {UnitOfMeasureSelect, UnitOfMeasureSelectProps} from "./UnitOfMeasureSelect";
import {unitOfMeasureTypes} from "@ots-frontend/ots-data";

type Props = Omit<UnitOfMeasureSelectProps, "selector"> & {
  selector?: Omit<UnitOfMeasureSelectProps, "type">
};

export const VolumeUnitOfMeasureSelect = (props: Props) => {
  const {selector, ...rest} = props;

  return (
    <UnitOfMeasureSelect
      {...rest}
      selector={{
        ...selector,
        types: [unitOfMeasureTypes.volume]
      }}/>
  );
};
